var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("支付结果:"),_c('span',[_vm._v(_vm._s(_vm.isSuccess ? '成功' : '失败'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }